module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-sad-face-smiley-svgrepo-com.0bae4011.svg";